module.exports = __webpack_public_path__ + "assets/images/piramide-magica_b689987b00aacf5202f26e798020c063.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/piramide/piramide-magica.png
// module id = 213
// module chunks = 0